import React from 'react';
import { BodyLargeEmphasized, InfoRow, RowList, YStack } from 'smoothie';

import type { IncomeSplitHistoryRow } from '../../../entityTypes';
import IncomeSplitHistoryRules from './IncomeSplitHistoryRules';

const IncomeSplitHistoryModal = ({
    incomeSplitHistory,
}: {
    incomeSplitHistory: IncomeSplitHistoryRow | null;
}) => {
    if (!incomeSplitHistory) return null;

    const { account, amount, date, description, emailCopy } =
        incomeSplitHistory;

    return (
        <YStack gap={20} $sm={{ width: 500 }}>
            <YStack
                gap={8}
                borderRadius={8}
                backgroundColor="$gray200"
                padding={12}
            >
                <RowList rowHeaderProps={{ title: 'Income Split details' }}>
                    <InfoRow title="Account" value={account} />
                    <InfoRow title="Date" value={date} />
                    <InfoRow title="Amount" value={amount} />
                    <InfoRow title="Description" value={description} />
                </RowList>

                <YStack gap={8}>
                    <BodyLargeEmphasized>Rules execution:</BodyLargeEmphasized>
                    <IncomeSplitHistoryRules emailCopy={emailCopy} />
                </YStack>
            </YStack>
        </YStack>
    );
};

export default IncomeSplitHistoryModal;
